import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import { roleStr, ADD, EDIT, VIEW } from '../../../common/common';
import { timeFormat2 } from '../../../common/utils';
import Toast from '../../Layout/components/Toast';
import CaseAutoComplete from '../../Components/CaseAutoComplete';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .textFieldS': {
        width: '45%',
        marginRight: '30px',
    },
    '& .timesheet': {
        '& .textFieldHalf': {
            width: '45%',
            marginRight: '30px',
        },
        '& .textFieldHalf2': {
            width: '30%',
            marginRight: '10px',
        },
    },
    '& .textWapper': {
        width: '100%',
        // height: '717px',
        overflow: 'auto',
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textFieldF': {
            width: '100%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .opposing': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            width: '90px',
            marginLeft: '10px',
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .title2': {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#212C31',
        marginBottom: '10px',
    },
    '& .title3': {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#212C31',
        marginBottom: '10px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const HASMATTER = 'has';
const NOMATTER = 'no';
class TimsheetInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            case_number: "",
            matter_id: "",
            name: "",
            number: "",
            numberCopy: "",
            matterNote: "",
            timesheetNote: "",
            date: timeFormat2(),
            hours_type: "",
            hourTypeData: ['Billable', 'Admin', 'Billing', 'Research'],
            hours: 0,
            caseObj: null,
            radioValue: HASMATTER,
            showToast: false,
            toastMsg: "",
            toastState: "",

            casesData: [],
            matterData: [],
            btnName: this.btnName(this.props.state)
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.updateCaseObj = this.updateCaseObj.bind(this);
    }
    render() {
        const {
            case_number,
            matter_id,
            name,
            number,
            matterNote,
            timesheetNote,
            matterData,
            date,
            hours_type,
            hourTypeData,
            hours,
            caseObj,
            radioValue,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const { state } = this.props;
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.state.btnName}</Button>
            }
        }
        const caseView = () => {
            if (radioValue === HASMATTER) {
                if (state === VIEW) {
                    return <div>
                        <div className="title">Case Info</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="textField"
                            label="Case Number"
                            value={case_number}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                } else {
                    return <div>
                        <div className="title">Case Info</div>
                        <CaseAutoComplete
                            initCase={caseObj}
                            update={this.updateCaseObj}
                        />
                    </div>
                }
            }
        }
        const matterTitle = () => {
            if (radioValue === HASMATTER && case_number !== "") {
                return <div className="title">Matter Info</div>
            }
        }
        const matterView = () => {
            if (radioValue === HASMATTER) {
                if (state === VIEW) {
                    return <div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="textField"
                            id="number"
                            label="New Matter Number"
                            value={number}
                            onChange={e => this.handleChange(e, 'number')}
                            margin="dense"
                            variant="outlined"
                        />
                        <TextField
                            disabled={this.isDisabled()}
                            className="textField"
                            id="name"
                            label="New Matter Name"
                            value={name}
                            onChange={e => this.handleChange(e, 'name')}
                            margin="dense"
                            variant="outlined"
                        />
                        <TextField
                            disabled={this.isDisabled()}
                            className="textField"
                            id="notes"
                            label="Matter Notes"
                            multiline
                            rows="3"
                            value={matterNote}
                            onChange={e => this.handleChange(e, 'matterNote')}
                            margin="dense"
                            variant="outlined"
                        />
                        <div className="title">Matter Originating Department / Team / Attorney</div>
                        <div>
                            <TextField
                                disabled={true}
                                className="textFieldS"
                                id="office"
                                label="Office"
                                value={this.getHandleData("office")}
                                margin="dense"
                                variant="outlined"
                            />
                            <TextField
                                disabled={true}
                                className="textFieldS"
                                id="department"
                                label="Department"
                                value={this.getHandleData("dept")}
                                margin="dense"
                                variant="outlined"
                            />
                            <TextField
                                disabled={true}
                                className="textFieldS"
                                id="team"
                                label="Team"
                                value={this.getHandleData("team")}
                                margin="dense"
                                variant="outlined"
                            />
                            <TextField
                                disabled={true}
                                className="textFieldS"
                                id="member"
                                label="Member"
                                value={this.getHandleData("member")}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                        <div className="title">Matter Participants</div>
                        <div>
                            {this.userFormat().map((name, index) => (
                                <TextField
                                    key={index}
                                    disabled={true}
                                    className="textField"
                                    value={name}
                                    margin="dense"
                                    variant="outlined"
                                />
                            ))}
                        </div>
                    </div>
                } else if (state === EDIT && case_number !== "") {
                    return <TextField
                        id="matterinfo"
                        select
                        label="Matter"
                        className="textField"
                        value={matter_id}
                        onChange={e => this.handleSelect(e, "matter_id")}
                        margin="dense"
                        variant="outlined"
                    >
                        {matterData.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextField>
                }
            }
        }
        return (
            <Root>
                <div className="pageTitle">{this.props.title}</div>
                <div className="line"></div>
                <RadioGroup
                    aria-label="Gender"
                    name="gender1"
                    row
                    value={radioValue}
                    onChange={this.handleRadio}
                >
                    <FormControlLabel disabled={this.isDisabled()} value={HASMATTER} control={<Radio color="primary" />}
                        label="Matter" />
                    <FormControlLabel disabled={true} value={NOMATTER} control={<Radio color="primary" />}
                        label="No Matter" />
                </RadioGroup>
                {caseView()}
                {matterTitle()}
                {matterView()}

                {/* <Participate
                    ref={(child) => { this.participate = child }}
                    userList={this.userFormat()}
                    state={this.props.state}
                    addBtnName="add another participant"
                /> */}
                <div className="title">Timesheet Info</div>
                <div className="timesheet h">
                    <div className="textFieldHalf">
                        <div className="title2">Select Date</div>
                        <TextField
                            disabled={this.isDisabled()}
                            id="date"
                            type="date"
                            variant="outlined"
                            className="textField"
                            margin="dense"
                            value={date}
                            onChange={e => this.handleChange(e, 'date')}
                            style={{ margin: '0' }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    <div className="textFieldHalf2">
                        <div className="title2">Select Task Type</div>
                        <TextField
                            disabled={this.isDisabled()}
                            style={{ margin: '0' }}
                            id="hourtype"
                            select
                            className="textField"
                            value={hours_type}
                            onChange={e => this.handleChange(e, "hours_type")}
                            margin="dense"
                            variant="outlined"
                        >
                            {hourTypeData.map((name, index) => (
                                <MenuItem key={index} value={name}>
                                    {name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                    <div className="f">
                        <div className="title2">Total Hours</div>
                        <TextField
                            disabled={this.isDisabled()}
                            style={{ margin: '0' }}
                            id="hours"
                            className="textField"
                            value={hours}
                            onChange={e => this.handleChange(e, 'hours')}
                            margin="dense"
                            variant="outlined"
                            type="number"
                        />
                    </div>
                </div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="timesheetnotes"
                    label="Timesheet Notes"
                    multiline
                    rows="3"
                    value={timesheetNote}
                    onChange={e => this.handleChange(e, 'timesheetNote')}
                    margin="dense"
                    variant="outlined"
                />
                {/* <div className="title">Timesheet Originating Department / Team / Attorney</div>
                <LevelChoose
                    ref={(child) => { this.levelChoose = child }}
                    officeName={this.getTimesheetHanlder("office")}
                    deptId={this.getTimesheetHanlder("dept")}
                    teamId={this.getTimesheetHanlder("team")}
                    memberId={this.getTimesheetHanlder("member")}
                    state={this.props.state}
                    isDisabled={this.isDisabled()}
                /> */}
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        this.getCase(() => {
            this.initData();
        });
    }
    initData() {
        const { state, data } = this.props;
        if (state === VIEW || state === EDIT) {
            const case_number = data.matter ? data.matter[0].case.number : "";
            const caseObj = data.matter ? data.matter[0].case : null;
            const matter_id = data.matter ? data.matter[0].id : null;
            const matterData = data.matter ? data.matter : [];
            const name = data.matter ? data.matter[0].name : "";
            const number = data.matter ? data.matter[0].number : "";
            const numberCopy = data.matter ? data.matter[0].number : "";
            const timesheetNote = data.note ? data.note : "";
            const matterNote = data.matter ? data.matter[0].note : "";
            const date = timeFormat2(data.date);
            const hours_type = data.hours_type;
            const hours = this.changeSToH(data.hours);
            const radioValue = matter_id ? HASMATTER : NOMATTER;
            this.setState(() => ({
                matter_id,
                matterData,
                case_number,
                caseObj,
                name,
                number,
                numberCopy,
                timesheetNote,
                matterNote,
                date,
                hours_type,
                hours,
                radioValue
            }))
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    isMatterDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return true;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    updateCaseObj(caseObj) {
        if (caseObj) {
            const matterData = caseObj.matters;
            this.setState(() => ({
                caseObj,
                matterData,
                matter_id: ""
            }))
        }
    }
    handleCreate() {
        const {
            timesheetNote,
            date,
            hours,
            hours_type,
            matter_id,
            case_number,
            radioValue,
        } = this.state;

        // let teamObj = this.levelChoose.getData();
        // const handler_id = teamObj.handler_id;
        // const handler_team_id = teamObj.handler_team_id;
        // const handler_department_id = teamObj.handler_department_id;
        if (radioValue === HASMATTER) {
            if (case_number === "") {
                this.showToast("Please choose case", "warning")
                return;
            } else if (matter_id === "") {
                this.showToast("Please choose matter", "warning")
                return;
            }
        }

        let obj = {
            matter_id,
            note: timesheetNote,
            date: (Date.parse(new Date(date)) / 1000) + "",
            hours: this.changeHToS(hours),
            hours_type,
            has_matter: radioValue,
            // handler_id,
            // handler_team_id,
            // handler_department_id,
        }
        console.log(obj)
        this.props.handleCreate(obj);
    }
    handleCancel() {
        this.props.handleCancel();
    }
    //name和desc输入的内容
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleRadio(e) {
        let radioValue = e.target.value;
        this.setState(() => ({
            radioValue
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    getTimesheetHanlder(name) {
        const { data } = this.props;
        if (!data) return "";
        const userObj = data.handler;
        const deptObj = data.handler_department;
        if (name === "office") {
            return deptObj ? deptObj.office : "";
        } else if (name === "dept") {
            return deptObj ? deptObj.id : "";
        } else if (name === "team") {
            return deptObj ? deptObj.team.id : "";
        } else if (name === "member") {
            return userObj ? userObj.id : "";
        }
    }
    getHandleData(name) {
        const handlers = this.extAOrP("attorney");
        if (handlers.length <= 0) return "";
        const userObj = handlers[0].user;
        const deptObj = handlers[0].team;
        if (name === "office") {
            return deptObj ? deptObj.dept_info.office : "";
        } else if (name === "dept") {
            return deptObj ? deptObj.dept_info.name : "";
        } else if (name === "team") {
            return deptObj ? deptObj.name : "";
        } else if (name === "member") {
            return userObj ? userObj.first_name + " " + userObj.last_name : "";
        }
    }
    userFormat() {
        const users = this.extAOrP();
        if (users) {
            let userList = [];
            for (const userObj of users) {
                let name = "";
                const user = userObj.user;
                const userName = user.first_name + " " + user.last_name;
                const userEmail = user.email;
                name = userName + " - " + userEmail;
                userList.push(name);
            }
            return userList;
        }
        return [];
    }
    extAOrP(type) {
        const { data } = this.props;
        if (!data) return [];
        let attorneyArr = [];
        let participateArr = [];
        const handlerArr = data.matter ? data.matter[0].handler : [];
        if (!handlerArr) return [];
        for (const obj of handlerArr) {
            if (obj.is_origin_attorney) {
                attorneyArr.push(obj);
            } else {
                participateArr.push(obj);
            }
        }
        if (type === "attorney") {
            return attorneyArr;
        } else {
            return participateArr;
        }
    }
    //对象数组去重
    deduplicationObjArr(objArr, key) {
        const newMap = new Map();
        const deduplicationObjArr = objArr.filter((obj) => !newMap.has(obj[key]) && newMap.set(obj[key], 1));
        return deduplicationObjArr
    }
    //对象数组过滤出相同的obj
    filterObjArr(objArr, key, name) {
        let newObjArr = [];
        for (const obj of objArr) {
            if (obj[key] === name) {
                newObjArr.push(obj);
            }
        }
        return newObjArr
    }
    showIOrCName(obj, name) {
        if (name === "name") {
            if (obj.individual) {
                return obj.individual.first_name;
            } else if (obj.corporation) {
                return obj.corporation.name;
            }
        } else if (name === "email") {
            if (obj.individual) {
                return obj.individual.email;
            } else if (obj.corporation) {
                return "";
            }
        }
    }
    getTeamName(teamArr) {
        if (teamArr) {
            if (teamArr.length > 0) {
                return teamArr[0].name;
            }
        }
        return "";
    }
    changeHToS(h) {
        return parseFloat(h * 3600);
    }
    changeSToH(s, plusNum = 0) {
        let totalS = parseFloat(s) + parseFloat(plusNum);
        if (totalS) {
            return Math.floor(((totalS + 35) / 3600) * 100) / 100;
        } else {
            return 0;
        }
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    //----------------request-------------------------------
    getCase(callback) {
        let params = {
            // origin_attorney_id,
            page_index: 1,
            page_size: 1000
        }
        instance.get(BASE_URL + roleStr() + '/cases', { params }).then((res) => {
            const casesData = res.data.data;
            console.log(casesData)
            this.setState({
                casesData
            }, () => {
                callback();
            });
        })
    }
}

export default TimsheetInfo;